<template>
  
  <div class="ui segment">
    <h4 class="ui dividing header">Totais do Orçamento</h4>
    <form class="ui form">
      <div class="fields">
        <div class="four wide field">
          <label class="form-label">Total Sugerido</label>
          <span v-if="isObject(quotation.sugTotal)">Antes:  R$ {{ $formatCurrency(quotation.sugTotal.__old) }}</span>
          <p v-if="isObject(quotation.sugTotal)"></p>
          <span>R$ {{ isObject(quotation.sugTotal) ? $formatCurrency(quotation.sugTotal.__new) : $formatCurrency(quotation.sugTotal) }}</span>
        </div>
        <div class="four wide field">
          <label class="form-label">Média Desconto Sug.</label>
          <span v-if="isObject(quotation.sugDiscountAvg)">Antes: {{ $formatCurrency(quotation.sugDiscountAvg.__old) }} %</span>
          <p v-if="isObject(quotation.sugDiscountAvg)"></p>
          <span>{{ isObject(quotation.sugDiscountAvg) ? $formatCurrency(quotation.sugDiscountAvg.__new) : $formatCurrency(quotation.sugDiscountAvg) }} %</span>
        </div>
        <div class="four wide field">
          <label class="form-label">Média Comissão Sug.</label>
          <span v-if="isObject(quotation.sugCommissionAvg)">Antes: {{ $formatCurrency(quotation.sugCommissionAvg.__old) }} %</span>
          <p v-if="isObject(quotation.sugCommissionAvg)"></p>
          <span>{{ isObject(quotation.sugCommissionAvg) ? $formatCurrency(quotation.sugCommissionAvg.__new) : $formatCurrency(quotation.sugCommissionAvg) }} %</span>
        </div>
        <div v-if="canSeeRg()" class="four wide field">
          <label class="form-label">IMP Sugerido</label>
          <span v-if="isObject(quotation.sugImp)">Antes: {{ $formatCurrency(quotation.sugImp.__old) }} %</span>
          <p v-if="isObject(quotation.sugImp)"></p>
          <span>{{ isObject(quotation.sugImp) ? $formatCurrency(quotation.sugImp.__new) : $formatCurrency(quotation.sugImp) }} %</span>
        </div>
      </div>
      <div class="fields">
        <div class="four wide field">
          <label class="form-label">Total Aprovado</label>
          <span v-if="isObject(quotation.appTotal)">Antes: R$ {{ $formatCurrency(quotation.appTotal.__old) }}</span>
          <p v-if="isObject(quotation.appTotal)"></p>
          <span>R$ {{ isObject(quotation.appTotal) ? $formatCurrency(quotation.appTotal.__new) : $formatCurrency(quotation.appTotal) }}</span>
        </div>
        <div class="four wide field">
          <label class="form-label">Média Desconto Aprov.</label>
          <span v-if="isObject(quotation.appDiscountAvg)">Antes: {{ $formatCurrency(quotation.appDiscountAvg.__old) }} %</span>
          <p v-if="isObject(quotation.appDiscountAvg)"></p>
          <span>{{ isObject(quotation.appDiscountAvg) ? $formatCurrency(quotation.appDiscountAvg.__new) : $formatCurrency(quotation.appDiscountAvg) }} %</span>
        </div>
        <div class="four wide field">
          <label class="form-label">Média Comissão Aprov.</label>
          <span v-if="isObject(quotation.appCommissionAvg)">Antes: {{ $formatCurrency(quotation.appCommissionAvg.__old) }} %</span>
          <p v-if="isObject(quotation.appCommissionAvg)"></p>
          <span>{{ isObject(quotation.appCommissionAvg) ? $formatCurrency(quotation.appCommissionAvg.__new) : $formatCurrency(quotation.appCommissionAvg) }} %</span>
        </div>
        <div v-if="canSeeRg()" class="four wide field">
          <label class="form-label">IMP Aprovado</label>
          <span v-if="isObject(quotation.appImp)">Antes: {{ $formatCurrency(quotation.appImp.__old) }} %</span>
          <p v-if="isObject(quotation.appImp)"></p>
          <span>{{ isObject(quotation.appImp) ? $formatCurrency(quotation.appImp.__new) : $formatCurrency(quotation.appImp) }} %</span>
        </div>
      </div>
      <div class="fields">
        <div class="four wide field">
          <label class="form-label">Total Metragem</label>
          <span v-if="isObject(quotation.totalMeters)">Antes: {{ $formatInteger(quotation.totalMeters.__old) }}</span>
          <p v-if="isObject(quotation.totalMeters)"></p>
          <span>{{ isObject(quotation.totalMeters) ? $formatInteger(quotation.totalMeters.__new) : $formatInteger(quotation.totalMeters) }}</span>
        </div>
        <div class="four wide field">
          <label class="form-label">Total Peso Cobre</label>
          <span v-if="isObject(quotation.copperTotal)">Antes: {{ $formatCurrency(quotation.copperTotal.__old) }}</span>
          <p v-if="isObject(quotation.copperTotal)"></p>
          <span>{{ isObject(quotation.copperTotal) ? $formatCurrency(quotation.copperTotal.__new) : $formatCurrency(quotation.copperTotal) }}</span>
        </div>
        <div class="four wide field">
          <label class="form-label">
            Flex 2,5mm2
            <div v-if="isObject(quotation.hasFlexAlert)">
              <i v-if="quotation.hasFlexAlert.__old" class="exclamation circle red icon"></i>
              <i v-else class="check circle green icon"></i>
              <i v-if="quotation.hasFlexAlert.__new" class="exclamation circle red icon"></i>
              <i v-else class="check circle green icon"></i>
              <span v-if="isObject(quotation.flexPerc)" 
                :class="{ 'red text': [isObject(quotation.hasFlexAlert) ? quotation.hasFlexAlert.__old : quotation.hasFlexAlert] }">
                {{ $formatCurrency(quotation.flexPerc.__old) }} %</span>
              <p v-if="isObject(quotation.flexPerc)"></p>
              <span :class="{ 'red text': [isObject(quotation.hasFlexAlert) ? quotation.hasFlexAlert.__new : quotation.hasFlexAlert] }">
                {{ isObject(quotation.flexPerc) ? $formatCurrency(quotation.flexPerc.__new) : $formatCurrency(quotation.flexPerc) }} %</span>
            </div>
            <div v-else>
              <i v-if="quotation.hasFlexAlert" class="exclamation circle red icon"></i>
              <i v-else class="check circle green icon"></i>
              <span :class="{ 'red text': [isObject(quotation.hasFlexAlert) ? quotation.hasFlexAlert.__new : quotation.hasFlexAlert] }">
                {{ isObject(quotation.flexPerc) ? $formatCurrency(quotation.flexPerc.__new) : $formatCurrency(quotation.flexPerc) }} %</span>
            </div>
          </label>
          
        </div>
      </div>
      <div v-if="canSeeRg()" class="fields">
        <div class="four wide field">
          <label class="form-label">Total RG Mínimo</label>
          <span v-if="isObject(quotation.minRgTotal)">Antes: {{ $formatCurrency(quotation.minRgTotal.__old) }}</span>
          <p v-if="isObject(quotation.minRgTotal)"></p>
          <span>{{ isObject(quotation.minRgTotal) ? $formatCurrency(quotation.minRgTotal.__new) : $formatCurrency(quotation.minRgTotal) }}</span>
        </div>
        <div class="four wide field">
          <label class="form-label">Total RG Sugerido</label>
          <span v-if="isObject(quotation.sugRgTotal)" class="field">Antes: {{ $formatCurrency(quotation.sugRgTotal.__old) }} / 
            {{ $formatCurrency([isObject(quotation.sugTotal) ? quotation.sugTotal.__old : quotation.sugTotal]/[isObject(quotation.copperTotal) ? quotation.copperTotal.__old : quotation.copperTotal]) }}</span>
          <p v-if="isObject(quotation.sugRgTotal)"></p>
          <span class="field">{{ isObject(quotation.sugRgTotal) ? $formatCurrency(quotation.sugRgTotal.__new) : $formatCurrency(quotation.sugRgTotal) }} /
            {{ $formatCurrency([isObject(quotation.sugTotal) ? quotation.sugTotal.__new : quotation.sugTotal]/[isObject(quotation.copperTotal) ? quotation.copperTotal.__new : quotation.copperTotal]) }}</span>
        </div>
        <div class="four wide field">
          <label class="form-label">Total RG Aprovado</label>
          <span v-if="isObject(quotation.appRgTotal)">Antes: {{ $formatCurrency(quotation.appRgTotal.__old) }}</span>
          <p v-if="isObject(quotation.appRgTotal)"></p>
          <span>{{ isObject(quotation.appRgTotal) ? $formatCurrency(quotation.appRgTotal.__new) : $formatCurrency(quotation.appRgTotal) }}</span>
        </div>
      </div>
    </form>
  </div>

</template>

<script>
  
  import QuotationService from "@/services/quotation-service"
import disapproveDialog from './disapprove-dialog.vue'
  
  export default {
  components: { disapproveDialog },
    
    props: ["quotation"],    

    methods: {

      canSeeRg() {
        return QuotationService.canSeeRg()
      },

      isObject(value) {
        if (typeof value == "object" && value != null) {
          return true
        }
        return false
      },
    },
  }

</script>
